import { Injectable } from '@angular/core';
import { ICheckoutSession, ILineItem, IPaymentDetails, IResponse, ISuccess } from '@interfaces/index';
import { HttpService } from '@ui-components/services';
import { Observable } from 'rxjs';

interface IBillMeLaterResponse {
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class PaymentService {

  constructor(
    private _http_service: HttpService
  ) { }

  checkout(line_items: ILineItem[]): Observable<IResponse<ICheckoutSession>> {
    return this._http_service.post('payments/checkout', {line_items})
  };

  getPaymentDetails(session_id: string): Observable<IResponse<IPaymentDetails>> {
    return this._http_service.post('payments/get-payment-details', {session_id})
  }

  updatePayment(session_id: string): Observable<IResponse<void>> {
    return this._http_service.post('payments/update', { session_id })
  }

  success(session_id: string): Observable<IResponse<ISuccess>> {
    return this._http_service.post('payments/success', {session_id})
  }

  checkoutB2c(first_name: string, last_name: string, email_address: string, org_name: string, line_items: ILineItem[]): Observable<IResponse<ICheckoutSession>> {
    return this._http_service.post('payments/create-user-and-checkout',
    {
      first_name,
      last_name,
      email_address,
      org_name,
      line_items
    })
  };

  billMeLater(line_items: ILineItem[], org_id?: number): Observable<IResponse<IBillMeLaterResponse>> {
    return this._http_service.post('payments/bill-me-later', { line_items, org_id });
  }
}
